import React from 'react'
import { useSideMenu } from '../contexts/SideMenuContext'

const SideMenu: React.FC = () => {
  const { isOpen, closeMenu } = useSideMenu()

  return (
    <>
      {/* Overlay */}
      {isOpen && (
        <div 
          className="fixed inset-0 bg-black/50 backdrop-blur-sm z-40 md:hidden"
          onClick={closeMenu}
        ></div>
      )}
      
      {/* Side menu */}
      <div className={`
        fixed top-0 right-0 h-full w-64 bg-slate-900/95 backdrop-blur-xl border-l border-slate-700/50
        transform transition-transform duration-300 ease-in-out z-50 md:hidden
        ${isOpen ? 'translate-x-0' : 'translate-x-full'}
      `}>
        <div className="flex flex-col h-full pt-16">
          {/* Close button */}
          <button
            onClick={closeMenu}
            className="absolute top-4 right-4 p-2 text-slate-400 hover:text-white"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>

          {/* Menu items */}
          <nav className="flex-1 px-6 py-8 space-y-6">
            <a
              href="/"
              className="block text-slate-300 hover:text-cyan-400 transition-colors duration-200 font-jetbrains text-lg"
              onClick={closeMenu}
            >
              Inicio
            </a>
            <a
              href="/consoles"
              className="block text-slate-300 hover:text-cyan-400 transition-colors duration-200 font-jetbrains text-lg"
              onClick={closeMenu}
            >
              Consolas
            </a>
            <a
              href="/bios"
              className="block text-slate-300 hover:text-cyan-400 transition-colors duration-200 font-jetbrains text-lg"
              onClick={closeMenu}
            >
              BIOS
            </a>
            <a
              href="/legal"
              className="block text-slate-300 hover:text-cyan-400 transition-colors duration-200 font-jetbrains text-lg"
              onClick={closeMenu}
            >
              Aviso Legal
            </a>
          </nav>

          {/* Footer */}
          <div className="px-6 py-4 border-t border-slate-700/50">
            <div className="text-cyan-400 font-jetbrains text-sm">
              RetroRoom v2.0
            </div>
            <div className="text-slate-500 text-xs mt-1">
              Preservación Histórica
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default SideMenu